import React from "react";
import { CredentialProps } from "../CredentialProps";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";

interface AWSListPageProps extends NSARouterMakerResult, CredentialProps { }

export default class AWSListPage extends React.Component<AWSListPageProps>
{
	override render()
	{
		return (
			<CredentialLayout
				{...this.props}
				action={{
					description: "This section lists all the Amazon Web Services (AWS) credentials saved in your workspace, showing each one's name and identifiers. You can open, copy, edit, or delete any entry, review its change history, or create a new one.",
				}}
				pages={{
					entity: CredentialEntities.aws(this.props),
					list: {
						ui: {}
					}
				}}
			>
				<></>
			</CredentialLayout >
		);
	}
}